// TrackedItemRow primitive: status chip.
//
// Renders the per-state chip using the design-system Badge so the chrome
// is visually identical to the analyst-certification rows. ChipVariant
// tokens map to the closest Badge tone.

import { Badge } from "@/design-system/components/ui";
import type { ChipVariant, StateSet, TrackedItemState } from "./types";
import { resolveStateDef } from "./types";

type BadgeTone = "draft" | "info" | "review" | "finalized" | "error" | "gold" | "archived";

const VARIANT_TONE: Record<ChipVariant, BadgeTone> = {
  neutral: "draft",
  blue: "info",
  amber: "review",
  green: "finalized",
  red: "error",
  muted: "archived",
};

interface TrackedItemStatusChipProps {
  state: TrackedItemState;
  stateSet: StateSet;
  title?: string;
}

export function TrackedItemStatusChip({
  state,
  stateSet,
  title,
}: TrackedItemStatusChipProps) {
  const def = resolveStateDef(stateSet, state);
  return (
    <Badge status={VARIANT_TONE[def.chipVariant]} title={title}>
      {def.label}
    </Badge>
  );
}

/** Escalation outcome chip — mirrors the criteria-checklist EscalationOutcomeBadge. */
export function TrackedItemEscalationChip({
  status,
}: {
  status: "Pending" | "Approved" | "Denied";
}) {
  if (status === "Pending") {
    return <Badge status="review">Escalation Pending</Badge>;
  }
  if (status === "Approved") {
    return <Badge status="finalized">Escalation Approved</Badge>;
  }
  return <Badge status="error">Escalation Denied</Badge>;
}
